module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-"
  }, [_vm._v("Abandon Ship")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("January–March 2003")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I don’t give a shit")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "ital CharOverride-2"
  }, [_vm._v("who")]), _c('span', {
    staticClass: "ital CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("you are")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(", you’re not coming in ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("until I get clearance from Central Security authorizing you to enter this palace.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("It was January 2003 and twenty-one-year-old Fahdi ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("was on duty as a palace security guard at the Al Dora Farms compound outside Baghdad, one of former Iraqi ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("President Saddam Hussein’s smaller palaces he had gifted ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to his daughter. Fahdi had been serving as a lower-level ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("security guard for nearly a year, rotating several days a week to different palaces and government residences throughout Baghdad.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I was basically a rent-a-cop,” Fahdi explained to ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("me ten years later as we sat on the large front porch of ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("our rural Ohio home. My iPhone sat between us on a small ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("patio table with the voice recorder app engaged. Halfway ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("through a Marlboro cigarette, smoke swirling above his ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("head, he maintained a thousand-yard stare out across the ocean of corn crops blanketing the fields surrounding our house. The Midwest summer sun was setting before him, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("transforming the smoke into an ethereal manifestation, moving and dancing with its own personality around his dark silhouette.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Like most of the middle-and upper-class teens in Baghdad, at age fifteen, Fahdi was drafted into the Youth ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Union headed by Saddam Hussein’s infamous son, Uday. A ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("cross between the Boy Scouts and the YMCA, the union ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("was an organization designed to cultivate a strong sense of")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" nationalism and loyalty to Saddam, his family, and the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Ba’athist regime amongst the youth of Baghdad. Fahdi had ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("excelled as a member of the Youth Union, quickly ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("progressing beyond the basic club activities, and moving ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("up the ranks into the upper echelons of the organization ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("that offered paid positions and even full-fledged career paths in the areas of government security, community ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("organizing, and other social service professions throughout ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Iraq’s capital city and beyond. Although most these ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("positions were reserved for individuals who were related ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to either Saddam’s family or other senior government ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("officials, Fahdi was the next best thing, Christian.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("It’s a common misconception that Christians in Iraq ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("were persecuted and oppressed under Saddam’s regime. ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The reality for many Christian families in Baghdad was ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("quite the opposite. Saddam trusted Christians above many ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Muslim Arabs who were not blood-related to him, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("knowing they would never be a threat to his power due to ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("their small minority. Christians often held high-level ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("security positions and were employed as palace chefs and housecleaning staff; even one of Saddam’s closest advisors ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("and foreign ministers, Tariq Aziz, was a Catholic.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi worked part-time with the palace security ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("detail while attending Baghdad University, where he was an English Language major.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Practically everyone’s goal after high school was ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to attend either the Engineering College or Medical School ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to become a doctor. I checked out both of those schools ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("but ultimately decided the College of Languages was right for me. It had the highest percentage of hot chicks,” Fahdi ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("said with a sly smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("He’d received word from his bosses at the palace security forces “some people” may be stopping by the Al-Dora Farms palace that chilly January day, but typically it ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("only meant a couple of workers to perhaps fix a toilet or repair a broken window. The person standing before him ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("now, demanding entry into the palace grounds, was an Iraqi man flashing an Iraqi Intelligence Service badge identifying him as Officer Malwood. Behind him were ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("fifteen foreigners, either European or American, sitting in ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("four SUVs adorned with recognizable insignias")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The United Nations.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Just open the gate son,” Malwood said in a patronizing tone, looking at Fahdi through the large iron ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("gates of the palace wall. “These are official UN inspectors and we have clearance to enter the compound and have been authorized to look around inside the palace.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“That’s all well and good, but I’m still not opening this gate until I receive explicit instructions from my ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("supervisors to let you in,” Fahdi replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Listen here, you little shit,” Malwood spat back, “you will do as I say. I outrank you!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“With all due respect, not while I’m on the other side of this gate you don’t,” Fahdi replied as calmly as ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("possible, although nervous a hell.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“If you do not open these gates this instant, not ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("only will I make sure you lose this job, I’ll make sure they ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("cut off your balls and shove them in your mouth before chopping off your head!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi knew the United Nations was currently ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("roaming the country conducting weapons inspections at ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Saddam’s palaces, but many of the rumors coming through ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("were that American CIA members were also posing as UN ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Inspectors to infiltrate Iraq’s sensitive government ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("locations. Fahdi wanted to ensure he covered all his bases ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("before granting them access or it’d be his ass.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi told Malwood to wait in his ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("vehicle while he contacted Central Security to obtain official authorization for them to enter the compound. He headed to the communications shack and tried to reach his supervisors via phone—no answer. There were three other security guards on duty with Fahdi and the four of them conferred ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to decide how to handle the situation.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“You speak English Fahdi. Are those people out there really with the United Nations?” one of his fellow guards asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“They’re definitely speaking English, but I don’t ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("know where they’re from. All I know is none of us is saying ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("a word to any of them until we get orders.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“We were all scared shitless. We didn’t want to cause any issues by not letting the inspectors in. It was ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("common knowledge not to fuck with the UN, but we’d also ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("heard stories of one of the palace guards at another location who got in serious trouble for allowing the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("inspectors in and showing them things he wasn’t supposed ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to show them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("In the end, they all agreed it was safer not to let ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the inspectors in and piss them off than to let them in and feel the merciless hand of Central Security.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Finally, nearly an hour after the inspectors arrived, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the phone in the palace communications shack rang. Fahdi ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("answered it and was given permission from the Assistant ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Chief of Central Security to allow Malwood and the UN inspectors to enter the Al-Dora compound. “Let them in and let them see and do whatever they want,” the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Assistant Chief instructed Fahdi. “If they want to dig holes, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("let them dig. If they want to knock down walls, let them have at it. Whatever they want to do. You got it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes, sir, I understand. I didn’t mean to cause any ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("trouble, I just wanted to be sure before I")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Assistant Chief cut him off. “You’re not in any ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("trouble. You were right to wait for our confirmation.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi breathed a huge sigh of relief, then opened the gate. Malwood, still seething and wanting to ring his neck, flashed a fake smile and feigned an amiable mood ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("for the UN inspectors.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Once parked inside the gates, the UN inspectors climbed from their vehicles and broke into three groups. ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi made sure a palace guard accompanied each group. Fahdi never spoke a word of English to the Inspectors and, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("clearly, Malwood’s English was practically non-existent. The UN team had their own translator with them who did ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("all the communicating between the inspectors and the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Iraqis. Nevertheless, Fahdi listened intently to every word the inspectors in his group said. The groups moseyed at a leisurely pace around the palace, opening random doors ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("and taking quick looks inside some rooms while walking ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("right past others.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“It felt more like they were interested home buyers walking through a neighborhood open house ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("instead of UN inspectors searching for weapons of mass ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("destruction.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("One of the inspectors in each group carried a ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("gadget of some sort Fahdi believed was used to measure ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("radiation levels in the air, but their demeanor made it ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("clear they didn’t expect to find anything at that particular ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("palace.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("As Fahdi began escorting his group back toward the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("front of the compound, the palace chef intercepted the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("group and informed Fahdi he’d received a call instructing him and his crew to prepare lunch for the “guests.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("Son-of-a-bitch!")]), _c('span', {
    staticClass: "ital CharOverride-4"
  }), _c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("We")]), _c('span', {
    staticClass: "ital CharOverride-4"
  }), _c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("have")]), _c('span', {
    staticClass: "ital CharOverride-4"
  }), _c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "ital CharOverride-4"
  }), _c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("feed")]), _c('span', {
    staticClass: "ital CharOverride-4"
  }), _c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("these")]), _c('span', {
    staticClass: "ital CharOverride-4"
  }), _c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("assholes, too?")]), _c('span', {
    staticClass: "ital CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Fahdi")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("directed")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("everyone")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("dining")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("room")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("where the inspectors and Malwood spent the next two hours ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("laughing")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("joking")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("while")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("dining")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("on")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("lamb")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("rice.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Fahdi")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("other")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("palace")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("guards")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("stood")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("quietly")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("in the shadows thinking to themselves, ")]), _c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("Holy shit, are these people ever going to leave?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Finally, the UN team leader glanced at his watch ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("and was visibly surprised by the late hour. He announced ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("they really needed to be getting on their way as the sun ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("was beginning to set; that they had to be back to wherever ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("they were staying before dark.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("As the UN vehicles disappeared into a cloud of ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("dust, Fahdi called Central Security and told the Assistant Chief the inspectors had departed.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I need you and the other guards to each write fully-detailed reports of everything the inspectors and their Iraqi Intelligence escort did during their visit,” the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Assistant Chief instructed. “I want to know what they said, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("what they saw, where they went, what they ate, everything. If they used the bathroom, it better be in the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("report how long they were in there and if they took a shit ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("or pissed. You got it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Even though Fahdi spoke English and understood almost every word the inspectors said, he still wasn’t sure ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("what to put in the report.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I was afraid they’d be disappointed because ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("nothing interesting or really noteworthy happened. Each ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("time we directed the inspectors into one of the palace rooms, all they could say was, ‘Wow! This is absolutely ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("beautiful.’ So, my report essentially read: We walked into ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("a room and they said, ‘Wow.’ We walked into another room and they said, ‘Wow.’”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("A couple of days later, Fahdi and the other three guards on duty with him at Al-Dora during the UN inspection were ordered to report to Central Security ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Command. The Assistant Chief had them all sit in front of a television and pressed play on a VCR. It was a recording of ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("a newscast that had recently come across one of the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("twenty-four-hour European news outlets. According to the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("report, the UN had recently reported being blocked for ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("several hours from entering one of the palaces in the Al-")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Dora area on the outskirts of Baghdad, and it was ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("suspected the officials inside the palace were using that ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("time to destroy incriminating evidence pointing to Iraq’s ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("harboring of WMDs or perhaps hiding actual weapons.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Are you fucking kidding me?” Fahdi protested, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("immediately fearing they were in deep shit.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“This is total bullshit!” another guard said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“All those fuckers did was come in and marvel at ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the damn closet space and the pretty bathrooms!” Fahdi ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("declared.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Then they ate all our food,” the other guard added. “The news report failed to mention they spent ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("twice as much time enjoying lunch as they did ‘inspecting’ ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("anything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Everyone calm down,” the Assistant Chief piped ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("in. “No one’s in trouble, I just thought you boys would be ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("interested in seeing this. We feel you handled everything ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("well and did what you were supposed to do. Everyone ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("knows the Americans own the Western media and were ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("going to say whatever the U.S. tells them to say. But it’s ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("clear the inspectors aren’t interested in learning the truth. They’re simply here as a front to give the U.S. a false edict ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to eventually declare war. There will be an official order going out to the entire Palace Guard: no one is to allow any more UN inspectors into any of the compounds. ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Dismissed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("A little over a month later, Fahdi was on security duty at a palace in Saddam’s hometown of Tikrit, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("approximately 250 km north of Baghdad; one much larger ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("than the al-Dora compound and belonged to Uday Hussein. The Palace Guard referred to it as the “Island ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Palace” as it was situated on a ten-acre peninsula jutting ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("out into the Tigris River. The palace itself was over 10,000 square feet with twelve bedrooms and separate quarters on the")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" outskirts of the premises where the palace staff and ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("security detail, which was typically comprised of six palace ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("guards, stayed while on duty.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Two days before U.S. President George Bush ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("appeared on television making his famous speech, giving ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Saddam and his sons forty-eight hours to surrender before ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the U.S. officially invaded, Fahdi and the five other palace ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("guards on duty with him were eating dinner in the guard ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("house discussing the impending war with America. None ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("of the six thought the U.S. would really invade Iraq with ground forces.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“It’ll probably just be like the cruise missile bombings Clinton did in ’96,” one of the guards ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("commented as he stuffed a handful of lamb and rice in his ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("mouth.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yeah, probably a few smart bombs and then ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("everything will go back to normal,” another added.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I don’t know. They seem damn pissed since the 9/11 attacks,” a third chimed in. “George Bush doesn’t ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("seem like he’s fucking around. They’ve been bombing the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("shit out of Afghanistan for the past year.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“But none of the terrorists on 9/11 were Iraqi,” Fahdi said. “We had nothing to do with it and don’t have any ties with Al-Qaeda. Why the hell would they come after us?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("As the world knows, Bush made good on his promise. On March 20, 2003, approximately ninety minutes after the lapse of the forty-eight-hour deadline, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("bombs began falling on Baghdad. And shortly thereafter, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ground forces crossed the border from Kuwait into Iraq. The war had started.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi and the other guards remained at the Island ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Palace, but communication with Central Security in ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Baghdad had gone dark the day the invasion started. They ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("all decided to wait it out and stay put until they heard word from higher up. News and information from Baghdad ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("was coming in via phone calls between the palace staff ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("and their families back in the capital city.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The morning after the invasion started, Fahdi ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("managed to get a hold of his younger brother, Fareed, who ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("was in Baghdad with their mother and thirteen-year-old sister, Farrah.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“So far, it seems they’re only bombing government ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("buildings and palaces,” Fareed relayed over the phone. ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“But we are going to go ahead and head north to the village. Mom is packing now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi and his siblings were all born in Baghdad and ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("had lived in the city all their lives, but Fahdi’s parents were ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("originally from a small Christian village in Northern Iraq, outside Mosul near the Kurdish region. Fahdi’s ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("grandparents and most of his extended family still lived in ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the village, and his family visited often. Fahdi had spent ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("many holiday breaks and summer days running across the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("green hillsides of the rural village. It was a perfect location ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to wait out U.S. bombings of Baghdad. The family had ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("been forced to go there on several occasions since Fahdi ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("was a small child.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Do you want to come with us?” Fahdi’s brother asked him. “Since they are bombing palaces, they’ll ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("probably start going after ones outside of Baghdad soon, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("especially in Tikrit. We can stop and pick you up on our way north.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“No, I have to stay,” Fahdi replied solemnly. “If I ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("abandon my post, we’ll have to pray the Americans burn ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("this country to the ground or it’ll be my ass.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Okay, but promise me you won’t be a martyr.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Don’t worry, I’m not that loyal,” Fahdi replied,")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" j")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("okingly.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("As the aerial bombardment of Baghdad")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" continued—")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the infamous “shock and awe” stage of the invasion")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("thousands of civilians fled the city and many came through ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Tikrit on their way north. One of the guards or other staff ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("at the Island Palace would periodically drive into Tikrit to ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("gather information on what was happening in Baghdad from the people passing through. Rumor had it, the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Americans and British were fighting to take Iraq’s largest southern city, Basra, and U.S. ground forces were moving toward Baghdad, which was somewhat accurate.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Every hour, Fahdi or one of the other security guards tried calling Central Security in Baghdad, but all ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("they got was a consistent busy tone.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("A few days after the invasion began, Fahdi heard ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the distinct whirring sound of incoming cruise missiles ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("overhead. The U.S. began bombing known military bases ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("around Tikrit, but everyone in the Island Palace knew it ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("was only a matter of time before they were on the menu. ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The staff—cooks, the cleaning crew, gardeners, etc.—all abandoned the Island Palace the day after the bombings in ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Tikrit started, but Fahdi and the other palace guards ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("remained behind. If they fled, and the Americans decided to pack up and go home before the country fell, they’d be ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("dead men for disserting. They felt secure in the guard ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("quarters, about 100 meters from the main house. Should the Americans decide to target the Island Palace, they’d probably drop a bomb smack in the center of it.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("After clearing the palace of provisions and ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("relocating supplies to the guard quarters, they refrained ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("from going anywhere near the main house. Information ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("coming in from Baghdad was growing bleaker by the hour. ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Word on the street was the government had all but ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("collapsed and top officials had gone underground or were on the run. Nearly two weeks after communications went ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("dark with Central Security, Fahdi and the other guards ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("decided to discuss their options.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I think it’s time for us to go guys,” Harith, one of the guards, said, and a couple of the others nodded in agreement. “We haven’t heard a word from Central Security in days. The government is gone and the Americans are about to take Baghdad. They’ll shoot us ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("where we stand if we’re still here when they come to take ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("this place.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi remained silent, not convinced the government was completely gone and feared what his Iraqi supervisors would do to him for disserting his post ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("more than what the Americans may do to him should they ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("show up.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Fahdi, man, what are you thinking?” one of the guards asked, noticing Fahdi’s silence. “You’re awfully ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("quiet.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I’m not leaving,” Fahdi responded shaking his head. “Not until someone above me either calls or ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("personally comes and tells me to leave. If we get caught abandoning our post, they will execute us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“There’s no one left!” Harith retorted. “It’s all over! I’m leaving tonight and anyone who wants to leave, too, is ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("welcome to join me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Around midnight, four of the guards left, leaving ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi and one other guard, Saif, alone at the Island Palace. ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The two took turns calling Central Security every fifteen minutes, but the busy signal continued. Another missile ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("whirred overhead across the night sky and connected with ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("its target in a massive explosion just a few kilometers from ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the them.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I’m beginning to think we should have left with ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the others,” Saif said in a somber tone.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I’m beginning to think you’re right,” Fahdi agreed. ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Let me make one more phone call.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“No one’s there, man. Central Security has been abandoned. I’m sure of it now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I’m not calling them,” Fahdi replied and dialed the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("number of his next-door neighbor in Baghdad, Waleed, who was a senior level official in the Ministry of Foreign ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Affairs. He hoped to learn a little more about the state of ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the government from him before making a final decision. “It’s ringing,” Fahdi exclaimed, excited to hear something other than a busy tone. He closed his eyes in relief at the sound of Waleed’s voice on the other end.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Waleed, it’s Fahdi, from next door.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Fahdi? Are you home?” Waleed asked confused. “I ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("thought I just saw your family leaving.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“They did. I’m not with them. I’m on duty at the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Island Palace. We can’t get a hold of Central Security. We ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("haven’t heard anything from them in two weeks and we ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("were wondering … I mean, we’re not sure …”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Leave ")]), _c('span', {
    staticClass: "ital CharOverride-2"
  }, [_vm._v("now")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(",” Waleed replied plainly, under")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("standing Fahdi was fishing for some sort of permission or ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("reason to abandon his post.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“But, what if—")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "ital CharOverride-2"
  }, [_vm._v("Leave now")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("!” Waleed reiterated more firmly. “And ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("if anyone asks, you can tell them I told you to leave. But ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("trust me, no one’s going to ask, ever.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Okay, we will,” Fahdi replied, half-relieved and ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("half-distressed.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“But don’t come back to Baghdad,” Waleed ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("advised. “It’s literally a warzone here. I’m on the way out ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("myself. They’re bombing the shit out of us and ground ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("forces are on their way. It’s over. Good luck, my friend.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Good luck to you, too.” And with that, Fahdi hung ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("up the phone.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Saif, get your stuff. We’re leaving.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Thank God,” Saif muttered under his breath.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The two gathered their personal belongings, along ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("with any food and supplies that were easy to pack, and ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("stuffed everything in the backseat of Fahdi’s car. They did their best to secure the compound, double-checking every ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("window, door, and gate to ensure they were locked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Did you make sure the kitchen doors around back were locked?” Fahdi asked before they got in the car.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Everything’s locked.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Are you sure?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Go double check anyway. I’m going to check the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("front again.” Fahdi doubled-timed it toward the front of the palace.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Saif huffed at Fahdi’s nagging but went around ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("back to check the kitchen doors again. The two met back up at the car and decided they’d done all they could. Time ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to abandon ship.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi slipped into the driver’s seat of his BMW sedan and Saif climbed in on the passenger side. They exchanged a brief silent glance, then Fahdi turned the ignition. Clearing the massive iron gates of the palace’s front entrance, Fahdi brought the car to a quick halt. He hopped out and pulled the gates closed, securing them with a padlock. As it clicked, he took one last look at the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Island Palace, looming in the shadows, and inhaled deeply. ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("He knew once he climbed back in the car and drove away, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("there would be no turning back. He’d officially be a deserter. A traitor to his country. A wanted man by ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("whatever Iraqi government remained come daybreak.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi and Saif were only a few hundred yards ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("down the road when the missile struck. Fahdi watched as ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the Island Palace exploded into a ball of flames and dust in ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("his rearview mirror.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Well, it’s a good thing we made sure all the doors ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("were locked,” Saif said sarcastically as he and Fahdi hauled ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ass.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi remained silent, staring at the road ahead with a stony glare. The disintegration of the Island Palace")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" represented what was happening to his country as a whole. The Iraq he had known all his life was quickly burning to the ground.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77fb41ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VoicingtheEagle25.vue
// module id = 72
// module chunks = 0